import { UUID } from './UUID';
import { HeaderSection } from '../../_sections/Header';
import { PersonalSectionProps } from '../../_sections/Personal/PersonalSection';
import { NavigationSection } from '../../_sections/Navigation/NavigationSection';
import { FooterSection } from '../../_sections/Footer';
import { BreadcrumbSection, PageManagementSection } from '../../_sections/Breadcrumb/BreadcrumbSection';
import { ContentMultiColumnSection } from '../../_sections/Content/ContentMultiColumn';

export interface SectionWithWidgets<TWidgets = any> extends UUID {
  widgets: TWidgets[];
  contentMultiColumn?: ContentMultiColumnSection;
}

export const SectionTypes = {
  header: 'header',
  navigation: 'navigation',
  breadcrumb: 'breadcrumb',
  personal: 'personal',
  content: 'content',
  contentMultiColumn: 'contentMultiColumn',
  context: 'context',
  footer: 'footer',
  pageManagement: 'pageManagement',
} as const;

export interface Sections {
  [SectionTypes.header]?: HeaderSection;
  [SectionTypes.navigation]?: NavigationSection;
  [SectionTypes.breadcrumb]?: BreadcrumbSection;
  [SectionTypes.pageManagement]?: PageManagementSection;
  [SectionTypes.personal]?: PersonalSectionProps;
  [SectionTypes.content]: SectionWithWidgets;
  [SectionTypes.contentMultiColumn]?: ContentMultiColumnSection;
  [SectionTypes.context]?: SectionWithWidgets;
  [SectionTypes.footer]?: FooterSection;
}
